import styles from './styles.module.scss';

const TicketAttachmentNotification = () => {
  return <div className={styles.attachmentNotification} />;
};

export default TicketAttachmentNotification;
